import { type Context, type ReorderEvent } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

export function getOrderDetails(context: Context, reorderEvent: ReorderEvent) {
  const { orderId, lineItemId } = reorderEvent;

  return {
    orderId: lineItemId ? '' : (orderId ?? context.orderId),
    lineItemId: orderId ? '' : (lineItemId ?? context.lineItemId),
    orderType: reorderEvent.orderType ?? context.orderType,
    deliveryAddressName: reorderEvent.deliveryAddressName ?? context.deliveryAddressName,
    deliveryOrderDetail: reorderEvent.deliveryOrderDetail ?? context.deliveryOrderDetail,
    restaurantId: reorderEvent.restaurantId ?? context.restaurantId,
    restaurantSlug: reorderEvent.restaurantSlug ?? context.restaurantSlug,
    restaurantName: reorderEvent.restaurantName ?? context.restaurantName,
  };
}
